/**
 *
 * ModalContent
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import messages from './messages';
import LoginAlert from '../LoginAlert';
import DeleteAccount from './DeleteAccount';
import ConfirmEmailChange from './ConfirmEmailChange';
import { useModalContent } from './useModalContent';
import EmailRow from './EmailRow';
import PremiumRow from './PremiumRow';
import ProfileRows from './ProfileRows';
import SupporterPrompt from './SupporterPrompt';

function ModalContent({ param, accountDeleted, onDeleteSuccess }) {
  const {
    user,
    userData,
    pendingEmail,
    isMerge,
    emailChangeSuccess,
    showSupporterPrompt,
    handleCancelSubscription,
    handleEmailChangeRequest,
    handleEmailChangeConfirm,
    handleEmailChangeCancel,
    dismissEmailSuccess,
  } = useModalContent();

  if (accountDeleted) {
    return (
      <div className="mt-4">
        <Alert bsStyle="success">
          <FormattedMessage {...messages.deleteSuccess} />
        </Alert>
        <Alert bsStyle="info">
          <FormattedMessage {...messages.deleteCanLoginAgain} />
        </Alert>
      </div>
    );
  }

  if (!user.api) {
    return <LoginAlert />;
  }

  return (
    <>
      {param && (
        <Alert bsStyle="success">
          <FormattedMessage {...messages.paymentOK} />
        </Alert>
      )}
      <dl className="dl-horizontal">
        <EmailRow user={user} onRequestSuccess={handleEmailChangeRequest} />
        <PremiumRow
          user={user}
          onCancelSubscription={handleCancelSubscription}
        />
        <ProfileRows userData={userData} />
      </dl>
      {emailChangeSuccess && (
        <Alert bsStyle="success" onDismiss={dismissEmailSuccess}>
          <FormattedMessage {...messages.emailChangeSuccess} />
        </Alert>
      )}
      {pendingEmail && (
        <ConfirmEmailChange
          user={user}
          pendingEmail={pendingEmail}
          isMerge={isMerge}
          onConfirmSuccess={handleEmailChangeConfirm}
          onCancel={handleEmailChangeCancel}
        />
      )}
      {showSupporterPrompt && !pendingEmail && <SupporterPrompt />}
      <DeleteAccount
        user={user}
        userData={userData}
        userEmail={user.email}
        onDeleteSuccess={onDeleteSuccess}
      />
    </>
  );
}

ModalContent.propTypes = {
  param: PropTypes.string,
  accountDeleted: PropTypes.bool.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};

export default ModalContent;
